import Splitting from 'splitting';

export const headings = () => {
  Splitting({
    /* target: String selector, Element, Array of Elements, or NodeList */
    target: '[data-splitting]',
    /* by: String of the plugin name */
    by: 'lines',
    /* key: Optional String to prefix the CSS variables */
    key: null,
  });
};
